import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { translate } from "@/i18n";

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const { user } = useAuth();
  const [lang, setLangState] = useState(() => localStorage.getItem("nt-lang") || "en");

  useEffect(() => {
    if (user && user.language && user.language !== lang) {
      setLangState(user.language);
      localStorage.setItem("nt-lang", user.language);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.language]);

  useEffect(() => { document.documentElement.lang = lang; }, [lang]);

  const setLang = useCallback((l) => {
    setLangState(l);
    localStorage.setItem("nt-lang", l);
    if (user) api.put("/settings/preferences", { language: l }).catch(() => {});
  }, [user]);

  const t = useCallback((key) => translate(lang, key), [lang]);

  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
